module.exports = __webpack_public_path__ + "img/user-f.92b4abd.svg";